import { render } from "./CustomerAccommodationInquiryDetails.vue?vue&type=template&id=a30aaef8&ts=true"
import script from "./CustomerAccommodationInquiryDetails.vue?vue&type=script&lang=ts"
export * from "./CustomerAccommodationInquiryDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__